module.exports = __webpack_public_path__ + "static/img/banne1.0ce89b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/banne1.jpg
// module id = V3YK
// module chunks = 0